import { DOCUMENT_STAPLINGS_LIST_API } from '../constants/api'
import {
  BIRDVIEW_ATTENTION_API,
  BIRDVIEW_DOC_FLOWS_ORDERING,
  BIRDVIEW_DWELLER_ANNOUNCEMENTS_API,
  BIRDVIEW_DWELLER_DOCUMENTS_API,
  BIRDVIEW_DWELLER_HOME_API,
  BIRDVIEW_DWELLER_MESSAGES_API,
  BIRDVIEW_DWELLER_OBJECTS_API,
  BIRDVIEW_DWELLER_REQUESTS_API,
  BIRDVIEW_INSIGHTS_KPI_TILES_API,
  BIRDVIEW_INSIGHTS_OPENED_CLOSED_API,
  BIRDVIEW_INSIGHTS_REQUESTS_AGING_API,
  BIRDVIEW_INSIGHTS_REQUESTS_BY_BUILDING_API,
  BIRDVIEW_INSIGHTS_REQUESTS_BY_CATEGORY_API,
  BIRDVIEW_INSIGHTS_REQUESTS_BY_MANAGER_API,
  BIRDVIEW_INSIGHTS_REQUESTS_BY_STATUS_API,
  BIRDVIEW_MY_ACTIVITIES_API,
  BIRDVIEW_MY_COMMUNICATIONS_API,
  BIRDVIEW_MY_CRITICAL_REQUESTS_API,
  BIRDVIEW_MY_SERVICE_REQUESTS_API,
  BIRDVIEW_PORTFOLIO_OVERVIEW_API,
  BIRDVIEW_SECTION_ITEMS_LIMIT,
  BIRDVIEW_SUMMARY_API,
  BIRDVIEW_TEAM_LOAD_API,
} from '../constants/dashboard'
import { PAGE_DEFAULT_VALUE } from '../constants/route'
import { getApi, postApi } from '../utils/api'

export async function getBirdviewDocFlows(filters) {
  return postApi({
    data: {
      filters,
      ordering: BIRDVIEW_DOC_FLOWS_ORDERING,
      page: PAGE_DEFAULT_VALUE,
      size: BIRDVIEW_SECTION_ITEMS_LIMIT,
    },
    endpoint: DOCUMENT_STAPLINGS_LIST_API,
  })
}

export async function getBirdviewAttention(params) {
  return getApi({ endpoint: BIRDVIEW_ATTENTION_API, params })
}

export async function getBirdviewDwellerAnnouncements(params) {
  return getApi({ endpoint: BIRDVIEW_DWELLER_ANNOUNCEMENTS_API, params })
}

export async function getBirdviewDwellerDocuments(params) {
  return getApi({ endpoint: BIRDVIEW_DWELLER_DOCUMENTS_API, params })
}

export async function getBirdviewDwellerHome() {
  return getApi({ endpoint: BIRDVIEW_DWELLER_HOME_API })
}

export async function getBirdviewDwellerMessages(params) {
  return getApi({ endpoint: BIRDVIEW_DWELLER_MESSAGES_API, params })
}

export async function getBirdviewDwellerObjects(params) {
  return getApi({ endpoint: BIRDVIEW_DWELLER_OBJECTS_API, params })
}

export async function getBirdviewDwellerRequests(params) {
  return getApi({ endpoint: BIRDVIEW_DWELLER_REQUESTS_API, params })
}

export async function getBirdviewInsightsKpiTiles(params) {
  return getApi({ endpoint: BIRDVIEW_INSIGHTS_KPI_TILES_API, params })
}

export async function getBirdviewInsightsOpenedClosed(params) {
  return getApi({ endpoint: BIRDVIEW_INSIGHTS_OPENED_CLOSED_API, params })
}

export async function getBirdviewInsightsRequestsAging() {
  return getApi({ endpoint: BIRDVIEW_INSIGHTS_REQUESTS_AGING_API })
}

export async function getBirdviewInsightsRequestsByBuilding(params) {
  return getApi({
    endpoint: BIRDVIEW_INSIGHTS_REQUESTS_BY_BUILDING_API,
    params,
  })
}

export async function getBirdviewInsightsRequestsByCategory(params) {
  return getApi({
    endpoint: BIRDVIEW_INSIGHTS_REQUESTS_BY_CATEGORY_API,
    params,
  })
}

export async function getBirdviewInsightsRequestsByManager(params) {
  return getApi({
    endpoint: BIRDVIEW_INSIGHTS_REQUESTS_BY_MANAGER_API,
    params,
  })
}

export async function getBirdviewInsightsRequestsByStatus(params) {
  return getApi({ endpoint: BIRDVIEW_INSIGHTS_REQUESTS_BY_STATUS_API, params })
}

export async function getBirdviewMyActivities(params) {
  return getApi({ endpoint: BIRDVIEW_MY_ACTIVITIES_API, params })
}

// No scope: the feed is the caller's own, and `team` gets a manager 403.
export async function getBirdviewMyCommunications(params) {
  return getApi({ endpoint: BIRDVIEW_MY_COMMUNICATIONS_API, params })
}

export async function getBirdviewMyCriticalRequests(params) {
  return getApi({ endpoint: BIRDVIEW_MY_CRITICAL_REQUESTS_API, params })
}

export async function getBirdviewMyServiceRequests(params) {
  return getApi({ endpoint: BIRDVIEW_MY_SERVICE_REQUESTS_API, params })
}

export async function getBirdviewPortfolioOverview(params) {
  return getApi({ endpoint: BIRDVIEW_PORTFOLIO_OVERVIEW_API, params })
}

export async function getBirdviewSummary(params) {
  return getApi({ endpoint: BIRDVIEW_SUMMARY_API, params })
}

export async function getBirdviewTeamLoad(params) {
  return getApi({ endpoint: BIRDVIEW_TEAM_LOAD_API, params })
}
